<template>
  <div class="default-modal claim-modal">
    <div class="default-modal__header">
      <h3 class="default-modal__title">{{ data.date }} {{ data.title || "Регистрация на курс" }}</h3>
      <button type="button" class="default-modal__close" @click="$emit('close')">
        <IconComponent name="add" />
      </button>
    </div>
    <div class="default-modal__body claim-modal__body">
      <template v-if="step === 0">
        <div class="claim-modal__row">
          <RadioComponent
            v-for="(item, i) in types"
            :key="i"
            :checked="isChecked(item, form.type.value)"
            @change="changeRadio($event, item, 'type')"
          >
            <span>{{ item.title }}</span>
          </RadioComponent>
        </div>
        <div class="claim-modal__sides">
          <div class="claim-modal__side">
            <InputComponent
              v-model.trim="form.name.value"
              :error="form.name.error"
              title="Ваше имя"
              placeholder="Ваше имя"
            />
            <InputComponent
              v-model.trim="form.surname.value"
              :error="form.surname.error"
              title="Ваша фамилия"
              placeholder="Ваша фамилия"
            />
            <InputComponent
              v-model.trim="form.phone.value"
              :error="form.phone.error"
              title="Ваш телефон"
              mask="+7 (###) ### - ## - ##"
              placeholder="+7 (___) ___ - __ - __"
            />
            <InputComponent
              v-model.trim="form.email.value"
              :error="form.email.error"
              title="Ваш e-mail"
              placeholder="Ваш e-mail"
            />
          </div>
          <div class="claim-modal__side">
            <div v-if="form.childs.value && form.childs.value.length" class="claim-modal__childs">
              <div v-for="(child, index) in form.childs.value" :key="index" class="claim-modal__child">
                <DateComponent
                  :title="childTitle"
                  id="published_at"
                  mode="date"
                  :disabledDate="disabledDate"
                  v-model="form.childs.value[index].birth_date"
                />
                <div class="claim-modal__row">
                  <RadioComponent
                    v-for="(item, i) in genders"
                    :key="i"
                    :checked="form.childs.value[index] && isChecked(item, form.childs.value[index].type)"
                    @change="changeChildsRadio($event, item, index)"
                    v-show="
                      !(
                        form.type.value &&
                        form.type.value.code === $store.state._types.CODE_PARENT &&
                        item.code === $store.state._types.UNKNOWN_GENDER
                      )
                    "
                  >
                    <span>{{ item.title }}</span>
                  </RadioComponent>
                </div>
              </div>
              <button
                v-show="form.type.value && form.type.value.code === $store.state._types.CODE_PARENT"
                @click="addChild"
                type="button"
                class="btn btn--md btn--main claim-modal__child-add"
              >
                Добавить
              </button>
            </div>
            <button @click="claimCreate" type="button" class="btn btn--md btn--main">
              <FileIconComponent v-if="loading" name="loading" />
              <template v-else>Зарегистрироваться</template>
            </button>
          </div>
        </div>
      </template>
      <div v-else class="claim-modal__success">
        <h3>Добро пожаловать на курсы школы мам BabyMarket</h3>
      </div>
    </div>
    <div class="default-modal__footer claim-modal__footer">
      <span v-if="step === 0" class="claim-modal__terms">
        * Отправляя заявку вы соглашаетесь на
        <a href="/files/terms.pdf" target="_blank">обработку персональных данных</a>
      </span>
      <span v-else>
        * Мы отправили вам на почту письмо со ссылкой на курс лекций. Если вы не получили письмо проверьте
        папку "спам", иногда письма могут попадать в нее.
      </span>
    </div>
  </div>
</template>

<script>
import InputComponent from "components/inputs/InputComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
// import TextareaComponent from "components/inputs/TextareaComponent.vue";
import RadioComponent from "components/inputs/RadioComponent.vue";
import SCHOOL_CLAIM_CREATE from "gql/mutations/SchoolClaimCreate.graphql";
// import SelectComponent from "components/inputs/select/index.vue";
import IconComponent from "components/IconComponent.vue";
import DateComponent from "@/components/inputs/DateComponent.vue";
import moment from "moment";

export default {
  name: "SchoolClaimModal",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // step 0 - ввод данных для регистрации
      // step 1 - успешная регистрация
      step: 0,
      loading: false,
      form: {
        name: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        surname: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        phone: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        email: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        course: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        type: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        childs: {
          value: [],
          error: undefined,
          message: undefined,
        },
      },
      childTemplate: {
        birth_date: undefined,
        type: undefined,
      },
      types: [
        {
          title: "Я ожидаю ребенка",
          code: this.$store.state._types.CODE_PREGNANT,
        },
        {
          title: "Я мама или папа",
          code: this.$store.state._types.CODE_PARENT,
        },
      ],
      genders: [
        {
          title: "Мальчик",
          code: this.$store.state._types.MALE,
        },
        {
          title: "Девочка",
          code: this.$store.state._types.FEMALE,
        },
        {
          title: "Неизвестно",
          code: this.$store.state._types.UNKNOWN_GENDER,
        },
      ],
    };
  },
  created() {
    this.form.type.value = this.types[0];
    this.childTemplate.type = this.genders[0];
    this.addChild();
  },
  computed: {
    disabledDate() {
      if (this.form.type.value) {
        if (this.form.type.value.code === this.$store.state._types.CODE_PREGNANT) {
          return (date) => date <= new Date();
        }
        if (this.form.type.value.code === this.$store.state._types.CODE_PARENT) {
          return (date) => date >= new Date();
        }
      }
      return undefined;
    },
    childTitle() {
      if (this.form.type.value) {
        if (this.form.type.value.code === this.$store.state._types.CODE_PREGNANT) {
          return "Ожидаемая дата родов";
        }
        if (this.form.type.value.code === this.$store.state._types.CODE_PARENT) {
          return "Дата рождения ребенка";
        }
      }
      return undefined;
    },
  },
  methods: {
    claimCreate() {
      if (!this.loading) {
        this.loading = true;
        this.$apollo.provider.defaultClient
          .mutate({
            mutation: SCHOOL_CLAIM_CREATE,
            variables: {
              name: this.form.name.value,
              surname: this.form.surname.value,
              phone: this.form.phone.value,
              email: this.form.email.value,
              course: this.data?.id,
              type: this.form.type.value ? this.form.type.value.code : undefined,
              childs: this.form.childs.value.map((item) => {
                return {
                  type: item.type ? item.type.code : undefined,
                  birth_date: moment(item.birth_date).format("YYYY-MM-DD HH:mm:ss"),
                };
              }),
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(({ data }) => {
            setTimeout(() => {
              this.$emit("close");
            }, 30000);
            this.step = 1;
            this.loading = false;
          })
          .catch(({ graphQLErrors }) => {
            this.loading = false;
            this.parseGqlErrors(graphQLErrors);
          });
      }
    },
    addChild() {
      this.form.childs.value.push(JSON.parse(JSON.stringify(this.childTemplate)));
    },
    changeRadio(e, item, field) {
      if (e) {
        this.form[field].value = item;
        this.form.childs.value = [];
        this.addChild();
      }
    },
    changeChildsRadio(e, item, index) {
      if (e) {
        if (this.form.childs.value[index]) {
          this.form.childs.value[index].type = item;
        }
      }
    },
    isChecked(item, value) {
      return JSON.stringify(value) === JSON.stringify(item);
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].error = err.extensions.validation[key][0];
            }
          });
        }
      });
    },
  },
  components: {
    IconComponent,
    // SelectComponent,
    RadioComponent,
    // TextareaComponent,
    FileIconComponent,
    InputComponent,
    DateComponent,
  },
};
</script>

<style lang="stylus">
.claim-modal {
  width 100%
  max-width 950px

  .radio {
    font-size: 1em
    gap: 10px
  }

  .input__field,
  .date-select {
    font-size: 1em
  }

  &__body {
    display grid
    justify-content stretch
    align-items stretch
    gap 30px
    min-height: 40vh
    align-items: center

    .textarea__field {
      height 100px
    }
  }

  &__body .input,
  &__body .date-select,
  &__footer .btn {
    width 100%
  }

  &__row {
    display flex
    flex-wrap wrap
    align-items: flex-start
    gap 30px
    +below(480px) {
      gap: 15px
    }
  }

  &__sides {
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 50px
    +below(990px) {
      grid-gap 30px
    }
    +below(640px) {
      grid-template-columns 1fr
      grid-gap 20px
    }
  }

  &__side {
    display flex
    flex-direction: column
    gap 20px

    .btn {
      margin-top: auto
    }
  }

  &__childs {
    display flex
    flex-direction: column
    align-items: flex-start
    gap: 20px
  }

  &__child {
    width: 100%
    display: flex
    flex-direction: column
    gap: 10px

    &-add {
      width: auto
    }
  }

  &__terms {
    a {
      border-bottom: 1px solid var(--dark)
    }
  }
}
</style>
